module.exports = __webpack_public_path__ + "img/re.d6ad379a.gif";